import { Box, Stack } from "@mui/material";
import React from "react";
import VisitStatusChip from "./VisitStatusChip";
import { VisitStatuses } from "@caredna-marlin/utils/client";

interface Props {
  padding?: string;
  isCapacityPage?: boolean;
  sx?: object
}

export const VisitStatusKey: React.FC<Props> = ({ sx = {}}) => {
  return (
    <Stack direction="row" flexWrap="wrap" sx={sx}>
      {Object.values(VisitStatuses).map((status) => {
        return (
          <Box key={status} display="inline-block">
            <VisitStatusChip status={status} sx={{ m: 0.5 }} />
          </Box>
        );
      })}
      <Box display="inline-block">
        <VisitStatusChip status="Shift Coverage" sx={{ m: 0.5 }} />
      </Box>
      <Box display="inline-block">
        <VisitStatusChip status="Drive Time" sx={{ m: 0.5 }} />
      </Box>
    </Stack>
  );
};
